import React from 'react';
import {Field} from 'redux-form/immutable';
import {Card} from 'antd'
import {TextField , SelectField} from 'redux-form-antd'

import {
    required, nullValue1
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 2 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 22 },
    },
};

const CurrentSchoolData = props => {
    const school_bus_selesct = [
        {
            label: '-- 請選擇 --',
            value: '-1'
        },
        {
            value: '1',
            label: '幼稚園-雙語'
        },
        {
            value: '2',
            label: '幼稚園-全美語'
        }
    ]

    return (
        <Card title="目前就讀學校">
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label="學校類別"
                   options={school_bus_selesct} name="stud_preschool_select" type="text" disabled={false} ></Field>
            <Field {...formItemLayout} component={TextField} label="學校名稱"
                   name="stud_preschool_name" type="text"></Field>
        </Card>
    )
}
// export default TransferStudent
export default CurrentSchoolData


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/CurrentSchoolData.jsx